export default "__VITE_ASSET__DgE52KYH__ 640w, __VITE_ASSET__BSSVaZKF__ 1024w, __VITE_ASSET__DMExCAB3__ 1920w";